/**
 * Citations de chargement — écrites en interne.
 * (userFullName = auteur fictif, affiché sous la citation)
 *
 * Trois familles mélangées :
 *  1. Vannes maison (vocabulaire NEOCORNER)
 *  2. Faux logs techniques
 *  3. Maximes d'entrepôt
 */
export type LoaderQuote = {
    message: string;
    userFullName: string;
};

export const LOADER_QUOTES: readonly LoaderQuote[] = [
    // — 1. Vannes maison —————————————————————————————
    { message: 'On réveille les frigos…', userFullName: 'Frida Girer, technicienne froid' },
    { message: 'Comptage des viennoiseries, une par une…', userFullName: 'Aude Four, cheffe boulangère' },
    { message: 'Négociation en cours avec Urbantz…', userFullName: 'Théo Tinéraire, planificateur' },
    {
        message: 'Recherche de la colonne 12. Elle était là hier.',
        userFullName: 'Colin Douze, opérateur microstore',
    },
    {
        message: 'On demande gentiment à Nayax de répondre.',
        userFullName: 'Carl Bleue, monétique',
    },
    { message: 'Vérification des DLC. Toutes les DLC.', userFullName: 'Dédé Elcé, contrôle qualité' },
    { message: 'Le camion charge. Toi aussi.', userFullName: 'Camille Yon, cariste' },
    { message: 'On compte les bundles sur nos doigts…', userFullName: 'Rémi Plissage, préparateur' },
    {
        message: 'Réveil des thermomètres. Ils dormaient à 4 °C.',
        userFullName: 'Anne Degré, chaîne du froid',
    },
    {
        message: 'Un nouveau site vient d’arriver, on fait les présentations.',
        userFullName: 'Alain Stallation, onboarding',
    },
    { message: 'Les sandwichs sont en route.', userFullName: 'Sandrine Wich, livraison du midi' },
    {
        message: 'On rattrape une palette qui partait en vrille.',
        userFullName: 'Paul Ette, allée C',
    },
    { message: 'Le frais d’abord, le sec ensuite. Toujours.', userFullName: 'Alfred Raîcheur, réception' },

    // — 2. Faux logs techniques ——————————————————————
    { message: 'Réveil du serveur GraphQL…', userFullName: 'Serge Veur, admin sys' },
    { message: 'Apollo réfléchit. Beaucoup.', userFullName: 'Apolline Client, dev front' },
    {
        message: 'Conversion des données en quelque chose de lisible…',
        userFullName: 'Étienne Elle, data engineer',
    },
    {
        message: 'Ce chargement est plus long que prévu. On assume.',
        userFullName: 'Paul Mortem, astreinte',
    },
    { message: 'Mise en cache. Enfin, on espère.', userFullName: 'Kevin Validation, backend' },
    { message: 'On hydrate le composant, il avait soif.', userFullName: 'Rhéa Act, dev front' },
    { message: 'Résolution de 412 promesses…', userFullName: 'Sonia Sinc, dev JS' },
    { message: 'Tentative n°2. La première était timide.', userFullName: 'Rémi Try, ops' },
    {
        message: 'Tri de 18 000 lignes à la main. Enfin, presque.',
        userFullName: 'Ray Quête, analyste',
    },
    { message: 'Le serveur a bien reçu. Il prend son temps.', userFullName: 'Lara Tence, réseau' },
    {
        message: 'Compilation des filtres que personne n’utilise…',
        userFullName: 'Phil Trage, produit',
    },
    { message: 'Rien d’anormal. Juste lent.', userFullName: 'Mona Toring, supervision' },
    { message: 'On rafraîchit pour toi, inutile de cliquer.', userFullName: 'Sarah Fraîchit, temps réel' },

    // — 3. Maximes d’entrepôt —————————————————————————
    {
        message: 'Un stock bien rangé est un stock à moitié livré.',
        userFullName: 'Laurent Trepôt, chef d’entrepôt',
    },
    { message: 'Il n’y a pas de petite variation de stock.', userFullName: 'Alain Ventaire, gestion' },
    { message: 'Le bundle attend celui qui sait patienter.', userFullName: 'Yves Attend, préparation' },
    {
        message: 'Qui ignore la DLC la rencontre toujours deux fois.',
        userFullName: 'Perry Hamé, qualité',
    },
    {
        message: 'Le meilleur transfert est celui qu’on n’a pas eu à faire.',
        userFullName: 'Alex Pédition, logistique',
    },
    {
        message: 'Un inventaire juste vaut mieux qu’un inventaire rapide.',
        userFullName: 'Karl Ton, réception',
    },
    { message: 'Celui qui range la colonne connaît le site.', userFullName: 'Manu Tention, terrain' },
    {
        message: 'Le meilleur planogramme est celui qu’on respecte.',
        userFullName: 'Léa Tagère, merchandising',
    },
    {
        message: 'Deux cartons mal étiquetés valent zéro carton.',
        userFullName: 'Cody Barre, réception',
    },
    { message: 'La rupture commence toujours un vendredi.', userFullName: 'Ruth Ture, approvisionnement' },
    {
        message: 'On ne livre jamais deux fois exactement la même tournée.',
        userFullName: 'Gilles Vraison, chauffeur',
    },
];
